import { QrPreviewComponent } from '@shared/qr/components/qr-preview/qr-preview.component';
import { NgModule } from '@angular/core';
import { NgStyle } from '@angular/common';
import { QrCustomizePreviewComponent } from './components/qr-customize-preview/qr-customize-preview.component';

@NgModule({
  declarations: [QrPreviewComponent, QrCustomizePreviewComponent],
  imports: [NgStyle],
  exports: [QrPreviewComponent, QrCustomizePreviewComponent],
})
export class QrModule {}
